import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="17" height="17" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M16.264 2.121l-6.011 6.01 6.01 6.011-2.12 2.122-6.011-6.012-6.01 6.011L0 14.143 6.01 8.13 0 2.121 2.121 0l6.01 6.009L14.143 0l2.122 2.121z" /></svg>);